import type { NotificationResponseSourceSourceUser } from './notificationResponseSourceSourceUser';

/**
 * 알림 소스 정보
 */
export type NotificationResponseSource = {
  /** 알림을 발생시킨 사용자 정보 */
  sourceUser?: NotificationResponseSourceSourceUser;
  /** 알림을 발생시킨 사용자 ID */
  sourceUserId?: number;
};
